<div class="discover-container">
  @if (facade.todayTeaser$ | async; as teasers) {
    <div class="d-flex justify-content-center justify-content-md-between">
      @for (item of teasers; track $index) {
        @if ($index >= slideRange[0] && $index <= slideRange[1]) {
          <div class="discover-item d-flex flex-column justify-content-between" (click)="openDetails(item.id)">
            <div>
              <div class="zero-text p-base-med">{{ item.title }}</div>
              <div class="zero-text p-small-reg mt-2">{{ item.description }}</div>
            </div>
            <a class="zero-text link p-small-reg">{{ 'asset-class-overview.shared.discover-news.more' | transloco }}</a>
          </div>
        }
      }
    </div>
    <button class="left" [disabled]="slideRange[0] === 0" (click)="prev()">
      <svg class="icon icon-18">
        <use xlink:href="/assets/img/svgs/svgset.svg#chevron" />
      </svg>
    </button>
    <button class="right" [disabled]="slideRange[1] === teasers.length - 1" (click)="next()">
      <svg class="icon icon-18">
        <use xlink:href="/assets/img/svgs/svgset.svg#chevron" />
      </svg>
    </button>
  }
</div>

<ng-template #modal let-modal>
  <discover-article [cardType]="DiscoverCardType.Latest" (handleClose)="modal.dismiss()" />
</ng-template>
